import React from 'react';
import mySvg from './loadingSmall.svg'
import { Icon } from 'antd';

export default function Spinner(props) {
    return (
        // <div id="divLoading" className="clsLoading" style={{position:'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(255, 255, 255, 0.70)', zIndex:1029, display:'none'}}>
        //     <img src={mySvg} alt="loading..." style={{top:'45%', left:'50%', transform:'translate(-50%, -50%)', position:'absolute'}} />    
        // </div>
        <div style={{textAlign:'center', ...props.style}} {...props}>
            {/* <img src={mySvg} alt="loading..." /> */}
            <Icon type="loading" className="cor-primary" style={{fontSize: 30, ...props.iconStyle }} />
        </div>
    );
  }